import React from 'react';
import { string, bool, func, number } from 'prop-types';
import classnames from 'classnames';
import { SwitchFadeTransition } from 'components';

import './Tab.scss';

export default function Tab({ className, name, active, index, onClick }) {
    const rootClassnames = classnames(
        'navigation-tab',
        {
            'navigation-tab--active': active,
        },
        className,
    );

    return (
        <SwitchFadeTransition keyIn={name} className={rootClassnames}>
            <button name={name} onClick={evt => onClick(evt, index)}>
                {name}
            </button>
        </SwitchFadeTransition>
    );
}

Tab.propTypes = {
    className: string,
    name: string.isRequired,
    active: bool,
    index: number.isRequired,
    onClick: func,
};

Tab.defaultProps = {
    className: null,
    active: false,
    onClick: null,
};
